import { z } from 'zod'
import { DateTimeStringSchema } from './common'

export const NotificationDataSchema = z.object({
  id: z.number(),
  title: z.string(),
  body: z.string().nullable(),
  startAt: DateTimeStringSchema.nullable(),
  isRead: z.boolean(),
})

export const NotificationGetResponseSchema = z.object({
  notification: NotificationDataSchema.nullable(),
})

export const NotificationListResponseSchema = z.object({
  notifications: z.array(NotificationDataSchema),
})

export const NotificationsUnreadDataSchema = z.object({
  hasUnread: z.boolean(),
})

export const NotificationsUnreadResponseSchema = z.object({
  notificationsUnread: NotificationsUnreadDataSchema,
})

export type NotificationData = z.infer<typeof NotificationDataSchema>
export type NotificationGetResponse = z.infer<typeof NotificationGetResponseSchema>
export type NotificationListResponse = z.infer<typeof NotificationListResponseSchema>
export type NotificationsUnreadData = z.infer<typeof NotificationsUnreadDataSchema>
export type NotificationsUnreadResponse = z.infer<typeof NotificationsUnreadResponseSchema>
